

import TicketsView from "./components/Tickets";
import InvoiceDataView from "./components/InvoiceDataView";
import MyAccountView from "./components/MyAccount";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";





const Dashboard = () => {
  const btnClass = `linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200`;

  return (
    <div>
      {/* Charts */}

      {/* <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
        <TotalSpent />
        <WeeklyRevenue />
      </div> */}

      {/* Tables & Charts */}

      <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-1">
        <div>
          <MyAccountView />
        </div>
        {/* <div>
          <TicketsView />
        </div> */}
        <div>
          <InvoiceDataView />
        </div>
        <div>
        <button onClick={()=>{
          window.location.href = "https://mitaxiaeropuerto.com/views/index.php"
        }} className={btnClass}>
            Comprar boletos
          </button>
        </div>

        {/* Check Table */}
        {/* <div>
          <CheckTable
            columnsData={columnsDataCheck}
            tableData={tableDataCheck}
          />
        </div> */}

        {/* Traffic chart & Pie Chart */}

        {/* <div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
          <DailyTraffic />
          <PieChartCard />
        </div> */}

        {/* Complex Table , Task & Calendar */}

        {/* <ComplexTable
          columnsData={columnsDataComplex}
          tableData={tableDataComplex}
        /> */}

        {/* Task chart & Calendar */}

        {/* <div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
          <TaskCard />
          <div className="grid grid-cols-1 rounded-[20px]">
            <MiniCalendar />
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Dashboard;
